var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    attrs: {
      "title": "Objeto/Identificadores",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab && !_vm.store.isUpdate
    },
    on: {
      "click": function click() {
        return _vm.store.currentTab = 1;
      }
    }
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "10"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Objeto",
      "label-for": "objeto"
    }
  }, [_c('CadastroRapidoSelect', {
    ref: "buscarObjeto",
    attrs: {
      "entity-label": "objeto",
      "label": "descricao",
      "min-create-length": 3,
      "creating": _vm.criandoObjeto,
      "value": _vm.form.objeto,
      "options": _vm.objetos
    },
    on: {
      "input": _vm.setObjeto,
      "create": _vm.criarObjetoInline,
      "search": _vm.onSearchObjeto
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', [_vm._v(_vm._s(option.descricao))])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(_vm._s(option.descricao))])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do objeto ")])], 2)], 1)], 1)], 1), _vm.identificadores.length ? _c('b-row', _vm._l(_vm.identificadores, function (identificador) {
    return _c('b-col', {
      key: identificador.id_identificador,
      attrs: {
        "sm": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": identificador.descricao,
        "label-for": "identificador-".concat(identificador.id_identificador)
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "identificador-".concat(identificador.id_identificador),
        "value": _vm.identificadoresFilled[identificador.descricao],
        "placeholder": _vm.placeholderIdentificador(identificador),
        "maxlength": "30"
      },
      on: {
        "input": function input(value) {
          return _vm.changeValue(identificador.descricao, value);
        }
      }
    })], 1)], 1);
  }), 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };